/**
 * @flow
 * @relayHash 899412c4dbdde093cd1fa2233c3efa3d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ShopDepartmentsQueryVariables = {|
  vendorID?: ?string
|};
export type ShopDepartmentsQueryResponse = {|
  +taxons: $ReadOnlyArray<?{|
    +id: string,
    +ref_id: string,
    +name: string,
    +logo: ?string,
    +caption: ?string,
    +type: string,
    +children: ?$ReadOnlyArray<?{|
      +name: string,
      +id: string,
      +ref_id: string,
      +type: string,
      +caption: ?string,
      +children: ?$ReadOnlyArray<?{|
        +name: string,
        +id: string,
        +ref_id: string,
        +type: string,
        +caption: ?string,
      |}>,
    |}>,
  |}>
|};
export type ShopDepartmentsQuery = {|
  variables: ShopDepartmentsQueryVariables,
  response: ShopDepartmentsQueryResponse,
|};
*/


/*
query ShopDepartmentsQuery(
  $vendorID: ID
) {
  taxons(type: department, vendor_id: $vendorID) {
    id
    ref_id
    name
    logo
    caption
    type
    children(vendor_id: $vendorID) {
      name
      id
      ref_id
      type
      caption
      children(vendor_id: $vendorID) {
        name
        id
        ref_id
        type
        caption
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "vendorID",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "vendor_id",
  "variableName": "vendorID",
  "type": "ID"
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "caption",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v7 = [
  v1
],
v8 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "taxons",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "type",
        "value": "department",
        "type": "TaxonKind"
      },
      v1
    ],
    "concreteType": "Taxon",
    "plural": true,
    "selections": [
      v2,
      v3,
      v4,
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo",
        "args": null,
        "storageKey": null
      },
      v5,
      v6,
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "children",
        "storageKey": null,
        "args": v7,
        "concreteType": "Taxon",
        "plural": true,
        "selections": [
          v4,
          v2,
          v3,
          v6,
          v5,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "children",
            "storageKey": null,
            "args": v7,
            "concreteType": "Taxon",
            "plural": true,
            "selections": [
              v4,
              v2,
              v3,
              v6,
              v5
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShopDepartmentsQuery",
  "id": null,
  "text": "query ShopDepartmentsQuery(\n  $vendorID: ID\n) {\n  taxons(type: department, vendor_id: $vendorID) {\n    id\n    ref_id\n    name\n    logo\n    caption\n    type\n    children(vendor_id: $vendorID) {\n      name\n      id\n      ref_id\n      type\n      caption\n      children(vendor_id: $vendorID) {\n        name\n        id\n        ref_id\n        type\n        caption\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShopDepartmentsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v8
  },
  "operation": {
    "kind": "Operation",
    "name": "ShopDepartmentsQuery",
    "argumentDefinitions": v0,
    "selections": v8
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2a3cc5005798366a771549ffb1ea1034';
module.exports = node;
